import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
const getKhoState = state => state.kho;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi (formData) {
  const request = axiosApi().post(
    Constants.KHO_LIST_API, 
    formData
  )

  return handleRequest(request);
}

function detailRequestApi (formData) {
  const request = axiosApi().post(
    Constants.KHO_DETAIL_API, 
    formData
  )

  return handleRequest(request);
}

function khoUpdateRequestApi (formData) {
  const request = axiosApi().post(
    Constants.KHO_UPDATE_API, 
    formData
  )

  return handleRequest(request);
}

function* khoListRequestFlow () {
  const kho = yield select(getKhoState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, kho.formData)

    // dispatch the action with our widgets!
    yield put(brActions.khoListSuccess(results.data))

  } catch (error) {
    yield put(brActions.khoListError(error))
  }
}

function* khoDetailRequestFlow ({payload}) {
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.khoDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.khoDetailError(error))
  }
}

function* khoUpdateRequestFlow (action) {
  const kho = yield select(getKhoState);
  try {
    // grab the client from our action
    const result = yield call(khoUpdateRequestApi, kho.formData)

    // dispatch the action with our widgets!
    yield put(brActions.khoUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.khoUpdateError(error))
  }
}

function usersRequestApi (formData) {
  const request = axiosApi().post(
    Constants.USERS_LIST_API, 
    formData
  )

  return handleRequest(request);
}
function* usersListRequestFlow ({payload}) {
  try {
    // grab the client from our action
    const results = yield call(usersRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.usersListSuccess(results.data))

  } catch (error) {
    yield put(brActions.usersListError(error))
  }
}

function* khoWatcher () {
  yield [
    takeLatest(Constants.KHO_LIST_REQUESTING, khoListRequestFlow),
    takeLatest(Constants.KHO_DETAIL_REQUESTING, khoDetailRequestFlow),
    takeLatest(Constants.KHO_UPDATE_REQUESTING, khoUpdateRequestFlow),
    takeLatest(Constants.USERS_LIST_REQUESTING, usersListRequestFlow),
  ]
}

export default khoWatcher



// WEBPACK FOOTER //
// ./src/views/Kho/sagas.js